import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../../components/sinpermisos";
import Nav from "react-bootstrap/Nav";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const url = "https://api.dacapo.com.ve/public/compras";

const Comprasdacapo = () => {
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);
  const [pending, setPending] = useState(true);
  const [modalFactura, setModalFactura] = useState(false);
  const [selectedCompra, setSelectedCompra] = useState({});

  const abrirModalFactura = (row) => {
    setSelectedCompra(row);
    setModalFactura(true);
  };

  const cerrarModalFactura = () => {
    setModalFactura(false);
    setSelectedCompra({});
  };

  const peticionGet = async () => {
    await axios.get(url).then((response) => {
      setData(response.data);
      setFiltroBuscar(response.data);
      setPending(false);
    });
  };

  useEffect(() => {
    peticionGet();
  }, []);

  const columns = [
    {
      name: "Accion",
      button: true,
      cell: (row) => (
        <Nav>
          <button
            onClick={() => abrirModalFactura(row)}
            className="btn btn-default"
          >
            <FaIcons.FaEye />
          </button>
        </Nav>
      ),
    },
    {
      name: "REF",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: "Cod cliente",
      selector: (row) => row.idgeneral,
    },
    {
      name: "Accion",
      selector: (row) => row.tipo,
    },
    {
      name: "Monto",
      selector: (row) => row.monto,
    },
    {
      name: "Fecha",
      selector: (row) => row.fecha,
    },
    {
      name: "Adquisicion",
      selector: (row) => row.adquisicion,
    },
  ];

  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    const result = data.filter((resultdata) => {
      if (resultdata.adquisicion.toLowerCase().match(buscar.toLowerCase())) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  const descargarPDF = () => {
    const input = document.getElementById("factura");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "PNG", 0, 0);
      pdf.save("factura.pdf");
    });
  };

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "admin") {
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className="row">
                    <div className="col-md-1">Compras</div>
                    <div className="col-md-11 text-left"></div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title> Compras Registrados</Card.Title>
                
                  <p> Compras registradas en el sistema.</p>
                  <DataTable
                    columns={columns}
                    data={filtrobuscar}
                    noDataComponent="No hay elementos a mostrar"
                    progressPending={pending}
                    progressComponent={<Cargando />}
                    pagination
                    subHeader
                    subHeaderComponent={
                      <input
                        type="text"
                        placeholder="Buscar"
                        className="w-25 form-control"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                      />
                    }
                  />

                  <Modal isOpen={modalFactura} toggle={cerrarModalFactura}>
                    <ModalHeader toggle={cerrarModalFactura}>
                      Detalles de la Compra
                    </ModalHeader>
                    <ModalBody id="factura">
                      <div className="form-group">
                        <label style={{ fontWeight: "bold" }}>REF:</label>
                        <p>{selectedCompra.id}</p>
                      </div>
                      <div className="form-group" style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                          <label style={{ fontWeight: "bold" }}>Cod cliente:</label>
                          <p>{selectedCompra.idgeneral}</p>
                        </div>
                        <div>
                          <label style={{ fontWeight: "bold" }}>Fecha:</label>
                          <p>{selectedCompra.fecha}</p>
                        </div>
                      </div>
                      <div className="form-group">
                        <label style={{ fontWeight: "bold" }}>Concepto:</label>
                        <p>{selectedCompra.adquisicion}</p>
                      </div>
                      <hr />
                      <div className="form-group" style={{ textAlign: "right" }}>
                        <label style={{ fontWeight: "bold" }}>Total:</label>
                        <p>{selectedCompra.monto}</p>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={cerrarModalFactura}
                      >
                        Cerrar
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={descargarPDF}
                      >
                        Descargar
                      </button>
                    </ModalFooter>
                  </Modal>
                </Card.Body>
              </Card>
            </Sidebar>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Comprasdacapo;